import './TermsOfService.css';

export default function TermsOfService({ onBack }) {
  return (
    <div className="terms-container">
      <div className="terms-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      <div className="terms-card">
        <div className="terms-header">
          <a href="#" className="back-btn" onClick={(e) => { e.preventDefault(); onBack(); }}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Back
          </a>
          <h1>Terms of Service</h1>
          <div style={{ width: '80px' }}></div>
        </div>

        <div className="terms-content">
          <section>
            <h2>1. Introduction</h2>
            <p>
              Welcome to Costly Cure Portal ("Service"). These Terms of Service ("Terms") govern your use of our website, services, and products. By accessing or using the Service, you agree to be bound by these Terms. If you do not agree to any part of these Terms, you may not use the Service.
            </p>
          </section>

          <section>
            <h2>2. Use of Service</h2>
            <p>
              You agree to use the Service only for lawful purposes and in a way that does not infringe upon the rights of others or restrict their use and enjoyment of the Service. Prohibited behaviors include:
            </p>
            <ul>
              <li>Harassing or causing distress or inconvenience to any person</li>
              <li>Obscene or offensive language or content</li>
              <li>Disrupting normal flow of dialogue within our website</li>
              <li>Attempting to gain unauthorized access to our systems</li>
            </ul>
          </section>

          <section>
            <h2>3. Intellectual Property Rights</h2>
            <p>
              Unless otherwise stated, we own the intellectual property rights for all material on the Service. All intellectual property rights are reserved. You may view and print pages from the Service for personal use, subject to restrictions set in these terms and conditions.
            </p>
            <p>You must not:</p>
            <ul>
              <li>Republish material from the Service</li>
              <li>Sell, rent, or sub-license material from the Service</li>
              <li>Reproduce, duplicate, or copy material from the Service for commercial purposes</li>
              <li>Redistribute content unless content is specifically made for redistribution</li>
            </ul>
          </section>

          <section>
            <h2>4. User Accounts</h2>
            <p>
              When you create an account with us, you must provide information that is accurate, complete, and current at all times. You are responsible for safeguarding the password and for all activities that occur under your account. You must notify us immediately of any unauthorized uses of your account.
            </p>
          </section>

          <section>
            <h2>5. Content and Models</h2>
            <p>
              The Service allows you to upload, create, and manage AI models and content. You retain all ownership rights to your content, but grant us a license to use, reproduce, modify, and distribute your content as necessary to provide the Service. You represent and warrant that your content does not infringe on any third-party intellectual property rights.
            </p>
          </section>

          <section>
            <h2>6. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by applicable law, in no event shall Costly Cure, its directors, employees, or agents be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, arising out of your use of or inability to use the Service.
            </p>
          </section>

          <section>
            <h2>7. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless Costly Cure and its officers, directors, employees, and agents from any claims, damages, losses, liabilities, and expenses (including reasonable attorneys' fees) arising out of or related to your use of the Service or violation of these Terms.
            </p>
          </section>

          <section>
            <h2>8. Modifications to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to the Service. Your continued use of the Service following the posting of modified Terms means that you accept and agree to the changes.
            </p>
          </section>

          <section>
            <h2>9. Termination</h2>
            <p>
              We may terminate or suspend your account and access to the Service immediately, without prior notice or liability, for any reason whatsoever, including if you breach these Terms.
            </p>
          </section>

          <section>
            <h2>10. Governing Law</h2>
            <p>
              These Terms are governed by and construed in accordance with the laws of the jurisdiction in which Costly Cure operates, and you irrevocably submit to the exclusive jurisdiction of the courts located in that location.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us at support@canmage.com
            </p>
          </section>
        </div>

        <a href="#" className="back-btn-bottom" onClick={(e) => { e.preventDefault(); onBack(); }}>
          ← Back to Homepage
        </a>
        
      </div>
    </div>
  );
}
